import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const PageHero = ({ eyebrow, title, intro, testid }) => {
    const reduce = useReducedMotion();

    if (reduce) {
        return (
            <section className="border-b border-bronze/15 bg-cream" data-testid={testid}>
                <div className="mx-auto max-w-7xl px-6 pb-16 pt-36 sm:px-12 sm:pt-44 lg:px-20 lg:pb-24">
                    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-bronze">
                        {eyebrow}
                    </p>
                    <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-[1.15] tracking-tight text-ink sm:text-5xl lg:text-6xl">
                        {title}
                    </h1>
                    {intro && (
                        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-stone2">{intro}</p>
                    )}
                </div>
            </section>
        );
    }

    return (
        <section className="border-b border-bronze/15 bg-cream" data-testid={testid}>
            <div className="mx-auto max-w-7xl px-6 pb-16 pt-36 sm:px-12 sm:pt-44 lg:px-20 lg:pb-24">
                <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.15, ease: EASE }}
                    className="text-xs font-semibold uppercase tracking-[0.25em] text-bronze"
                >
                    {eyebrow}
                </motion.p>
                <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-[1.15] tracking-tight text-ink sm:text-5xl lg:text-6xl">
                    {title.split(" ").map((word, i) => (
                        <span key={`${word}-${i}`} className="inline-block overflow-hidden pb-1 align-bottom">
                            <motion.span
                                className="inline-block"
                                initial={{ y: "112%" }}
                                animate={{ y: "0%" }}
                                transition={{ duration: 0.85, delay: 0.3 + i * 0.055, ease: EASE }}
                            >
                                {word}
                                {i < title.split(" ").length - 1 ? " " : ""}
                            </motion.span>
                        </span>
                    ))}
                </h1>
                {intro && (
                    <motion.p
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.85, delay: 0.75, ease: EASE }}
                        className="mt-6 max-w-2xl text-lg leading-relaxed text-stone2"
                    >
                        {intro}
                    </motion.p>
                )}
            </div>
        </section>
    );
};

export default PageHero;
